/** The longest words the server takes in each field an attorney types, held equal to the API schema by a test. */
export const TEXT_LIMITS = {
  sectionTitle: 200,
  subsectionLine: 300,
  childKey: 100,
  childText: 500,
  figureDescription: 2000,
  figureWalkthrough: 20000,
  answer: 2000,
} as const;
